var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontRightLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 77,
    viewBox: "0 0 35 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2082 6.81606C30.5466 8.12735 33.9941 3.19532 33.9941 3.19532C33.9941 3.19532 33.0757 4.52132 33.4037 7.79952C33.7317 11.0777 33.8384 20.979 31.8579 24.5183C29.6565 28.4522 27.8307 36.5384 27.1751 40.9093C26.3883 47.2035 26.4102 50.3068 26.5194 51.0717C27.0439 52.383 26.5194 53.585 26.1916 54.0221C27.5029 60.9063 26.5194 61.8898 23.5691 63.8567C21.2088 65.4303 20.4001 66.2607 20.2909 66.4793C15.0457 73.3635 14.3901 73.3635 13.0788 73.3635C12.0298 73.3635 11.3304 74.0191 11.1119 74.347C8.22708 77.7563 6.41315 75.7675 5.86678 74.347C4.81776 75.9205 3.89986 75.0026 3.57204 74.347C2.52302 74.8715 2.04222 74.1284 1.93294 73.6913C1.67068 73.6913 1.38658 73.4728 1.2773 73.3635C1.01505 73.1012 1.60512 72.38 1.93294 72.0522H1.60512C0.556099 71.2654 2.9164 69.7575 4.22768 69.1018C6.63169 66.2607 12.0298 59.5951 14.3901 55.6612C17.3405 50.7439 16.6848 48.4492 16.6848 47.1379V26.4853C16.4226 11.2744 20.4603 0.900163 20.5535 0.572343C20.6468 0.244524 19.8697 5.50477 25.2082 6.81606Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontRightLeg);
export default __webpack_public_path__ + "static/media/FrontRightLeg.ce19a0d021dfe03fcedac464a4a85284.svg";
export { ForwardRef as ReactComponent };